import React, { JSXElementConstructor, ReactElement } from "react";
import clsx from "clsx";

import {
  Box,
  Columns,
  Column,
  Hidden,
  makeStylesSeeded,
  ColumnProps,
} from "@origin-digital/ods-core";

import SmallerLogo from "./SmallerLogo";
import { NavLink } from "./NavLink";
import { NavConfig } from "./NavConfig";
import { IKrakenAuthNavProps, KrakenNavLinkType } from "./interfaces";
import { MobileNav } from "./Mobile/MobileNav";
import { CollapsibleNavLink } from "./CollapsibleNavLink";
import { authNavRoutePrefix } from "./helpers/consts";

const useStyles = makeStylesSeeded(({ palette }) => ({
  navContainer: {
    borderBottom: `1px solid ${palette.grey["200"]}`,
  },
}));

export const KrakenAuthNav: React.FC<IKrakenAuthNavProps> = ({
  desktopVariant,
}) => {
  const styles = useStyles();
  const showFullHeader = desktopVariant !== "slim";
  return (
    <Box
      backgroundColor="white"
      className={clsx(styles.navContainer)}
      data-id="kraken-auth-nav"
    >
      <Columns space={["medium", "large"]}>
        <Column width="content">
          <SmallerLogo
            id="origin-logo"
            href={authNavRoutePrefix}
            desktopVariant={desktopVariant}
          />
        </Column>
        {showFullHeader ? (
          <Column width="flex" alignX={["left", "center"]}>
            <Hidden below="lg">
              <Columns
                space={{
                  xl: "xxxlarge",
                  lg: "xxlarge",
                }}
              >
                {
                  (NavConfig.filter(
                    ({ linkType }) => linkType === KrakenNavLinkType.HEADER
                  ).map((navLink) => (
                    <Column key={navLink.name} width="content">
                      <NavLink key={navLink.name} linkConfig={navLink} />
                    </Column>
                  )) as unknown) as ReactElement<
                    ColumnProps,
                    string | JSXElementConstructor<any>
                  >
                }
              </Columns>
            </Hidden>

            <Hidden above="md">
              <MobileNav />
            </Hidden>
          </Column>
        ) : null}
        {showFullHeader ? (
          <Column width="content">
            {
              (NavConfig.filter(
                ({ linkType }) => linkType === KrakenNavLinkType.ASIDE
              ).map((navLink) => (
                <CollapsibleNavLink key={navLink.name} linkConfig={navLink} />
              )) as unknown) as ReactElement<
                ColumnProps,
                string | JSXElementConstructor<any>
              >
            }
          </Column>
        ) : null}
      </Columns>
    </Box>
  );
};
